import { useSelector } from 'react-redux'
import {
  selectCreditRiskDataItem,
  selectCreditRiskDataTable,
} from '../store/slice'
import { ChartContent } from './ChartContent'
import { TableContent } from './tableContent'

export const CreditRiskScore = () => {
  const data = useSelector(selectCreditRiskDataTable)

  return (
    <div className="dFlex h100">
      <div className="flex1">
        <TableContent getDataFromRedux={selectCreditRiskDataItem} />
      </div>

      <div style={{ width: 350, marginLeft: 36 }}>
        <ChartContent dataChart={data} />
      </div>
    </div>
  )
}
